import React, { useEffect, useState } from "react";
import { classNames } from "../../utils";
import LoadingSpinner from "../../shared-components/LoadingSpinner";
import Summary360Social from "./Summary360Social";
import Summary360Documents from "./Summary360Documents";
import { SummaryItem } from "../docs/Reports360SummaryEditor";

import { PersonInfoApi } from "../../api/Person";

type Props = {
  summaryItems: SummaryItem[];
  isLoading: boolean;
  personEx?: PersonInfoApi;
  /** When false, Social Media tab is hidden (non-empty blueprint item_types excludes fama_reports). Empty/missing list defaults to shown — matches Workbench360. */
  hasFamaReport?: boolean;
};

const Summary360Body = (props: Props) => {
  const { summaryItems, isLoading, personEx, hasFamaReport = true } = props;
  const [activeTab, setActiveTab] = useState<string>("summary");

  useEffect(() => {
    if (!hasFamaReport) {
      setActiveTab((tab) => (tab === "social-media" ? "summary" : tab));
    }
  }, [hasFamaReport]);

  const tabs = [
    {
      id: "summary",
      label: "Summary",
    },
    ...(hasFamaReport
      ? [
          {
            id: "social-media",
            label: "Social Media",
          },
        ]
      : []),
    {
      id: "additional-documents",
      label: "Additional Documents",
    },
  ];

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="mt-6">
      <div className="print:hidden flex border-b-[1px] border-gray-200">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={classNames(
              "cursor-pointer pr-6 pb-2",
              activeTab === tab.id
                ? "text-green-600 border-b-2 border-green-600"
                : "text-gray-400"
            )}
          >
            {tab.label}
          </div>
        ))}
      </div>
      <div
        className={classNames(
          "mt-4 bg-white rounded-md px-6 py-6",
          activeTab === "additional-documents" ? " " : ""
        )}
      >
        {activeTab === "summary" && (
          <>
            {isLoading && <LoadingSpinner />}
            {summaryItems.length > 0 && (
              <div className="ql-editor">
                {summaryItems.map((item) => (
                  <div
                    key={item.external_id}
                    dangerouslySetInnerHTML={{ __html: item.body }}
                  />
                ))}
              </div>
            )}
            {summaryItems.length === 0 && !isLoading && (
              <div className="text-gray-500">
                This report contains no summary data.
              </div>
            )}
          </>
        )}
        {activeTab === "social-media" && hasFamaReport && <Summary360Social />}
        {activeTab === "additional-documents" && (
          <Summary360Documents personEx={personEx} />
        )}
      </div>
    </div>
  );
};

export default Summary360Body;
